import { GET_ME } from 'src/api/graphql/queries/me.gql';
import { runQuery } from 'src/api/apollo/runQuery';

export const getMe = async (options = {}) => {
	const { data } = await runQuery({
		query: GET_ME,
		fetchPolicy: options.fetchPolicy ?? 'cache-first',
	});

	return data?.me ?? null;
};
